export const penitentiaries = (state) => {
  return state.penitentiaries;
};

export const contador = (state) => {
  return state.contador;
};

export const cuadrado = (state) => {
  return state.contador * state.contador;
};

export const getPenitentiary = (state) => {
  return state.penitentiary;
};
